export default (params) => ({
  trigger: {
    name: 'product_specifications.read_property_explanation',
    params: params,
  },
  config: {
    schema: {
      property_name: {
        type: 'string',
      },
      property_value: {
        type: 'string',
      },
      sub_feature: {
        enum: [
          'specifications',
          'short_specifications',
        ],
      },
    },
    event: {
      name: 'interact_with_property',
      params: {
        method: 'explanation',
      },
    },
  },
});
